<template>
  <div class="search-page">
    <form v-on:submit="searchSubmit($event)">
      <div class="mobile-search">
        <div class="mobile-search-box">
          <input placeholder="Oklahoma City, OK" v-model="mobileSearch">
          <button class="search-btn" v-on:click="searchAction"><img src="/icons/search-white.svg" alt="Search"></button>
        </div>
        <div class="toggle-controls">
          <button type="button" :class="'secondary' + (mobileViewMap ? ' pressed' : '')"
                  v-on:click="mobileViewMap = !mobileViewMap">{{ mobileViewMap ? 'CLOSE' : 'VIEW MAP' }}
          </button>
          <button type="button" :class="'secondary' + (mobileViewFilters ? ' pressed' : '')"
                  v-on:click="mobileViewFilters = !mobileViewFilters">{{ mobileViewFilters ? 'CLOSE' : 'FILTERS' }}
          </button>
        </div>
      </div>
      <div class="search-box" :class="{expanded: mobileViewFilters}">
        <div class="top-tabs">
          <label :for="id+'_all'" :class="{active: search.tab === 'all'}"><input :id="id+'_all'" type="radio"
                                                                                 name="own_type" value="all"
                                                                                 v-model="searchTab">All
            Properties</label>
        </div>
        <div class="main-options">
          <div>
            <div class="property-types">
              <div class="check-column">
                <label :for="id+'_category-all'" class="check">
                  <input :id="id+'_category-all'" type="checkbox" name="category[]" value="all"
                         v-model="searchAllCategories"><span v-on:keypress="check($event)" class="checkbox"
                                                             tabindex="0"></span> All Properties
                </label>

                <div v-for="propertyTy in propertyTypes">
                  <label :for="id+'_'+propertyTy.text" class="check">
                    <input :id="id+'_'+propertyTy.text" type="checkbox" name="category[]" :value="propertyTy.text"
                           v-model="search.propertyType"><span v-on:keypress="check($event)" class="checkbox"
                                                               tabindex="0"></span>{{ propertyTy.text }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="option-set location">
            <div class="half"><label :for="id+'_city'">CITY</label><input :id="id+'_city'" name="city"
                                                                          v-model="search.city" placeholder="City">
            </div>
            <div class="half">
              <label :for="id+'_state'">STATE</label>
              <div class="select-arrow">
                <select :id="id+'_state'" name="state" v-model="search.state">
                  <option value=""></option>
                  <option v-for="state in states" :value="state">{{ state }}</option>
                </select>
                <label class="placeholder" v-if="search.state === ''">State</label>
              </div>
            </div>
            <div><label :for="id+'_state'">KEYWORD</label><input :id="id+'_state'" name="keyword"
                                                                 v-model="search.keyword" placeholder="Keyword"></div>
            <div>
              <label :for="id+'_type'">LISTING TYPE</label>
              <div class="select-arrow">
                <select :id="id+'_type'" name="type" v-model="searchTab">
                  <option value="">All Properties</option>
                  <option value="Sales">For Sale</option>
                  <option value="Lease">For Lease</option>
                </select>
              </div>
            </div>
          </div>
          <div class="option-set middle">
            <div><label :for="id+'_agent'">AGENT NAME</label>
              <div class="select-arrow">
                <select :id="id+'_agent'" name="agent" v-model="search.agentName">
                  <option value=""></option>
                  <option v-for="broker in brokers" :value="broker.search">{{ broker.name }}</option>
                </select>
                <label class="placeholder" v-if="search.agentName === ''">Agent Name</label>
              </div>
            </div>
            <div class="half"><label :for="id+'_price-min'">PRICE MIN</label>
              <input :id="id+'_price-min'" name="price_min" v-model="search.priceMin" placeholder="Price Min"></div>
            <div class="half"><label :for="id+'_price-max'">PRICE MAX</label>
              <input :id="id+'_price-max'" name="price_max" v-model="search.priceMax" placeholder="Price Max"></div>
          </div>
          <div class="option-set last">
            <div class="half"><label :for="id+'_sf-min'">SF MIN</label>
              <input :id="id+'_sf-min'" name="sf_min" v-model="search.squareFtMin" placeholder="SF Min"></div>
            <div class="half"><label :for="id+'_sf-max'">SF MAX</label>
              <input :id="id+'_sf-max'" name="sf_max" v-model="search.squareFtMax" placeholder="SF Max"></div>
            <div class="half"><label :for="id+'_acre-min'">ACREAGE MIN</label>
              <input :id="id+'_acre-min'" name="acre_min" v-model="search.acreageMin" placeholder="Acreage Min"></div>
            <div class="half"><label :for="id+'_acre-max'">ACREAGE MAX</label>
              <input :id="id+'_acre-max'" name="acre_max" v-model="search.acreageMax" placeholder="Acreage Max"></div>
          </div>
        </div>
        <div class="flex justify-between flex-row-reverse items-end">
          <p class="multifamily order-1 flex-grow flex-shrink" v-if="search.tab==='Sales'">For multifamily investment
            sales, please visit our affiliate <a href="http://listings.arausa.com/">ARA Newmark</a></p>
          <div class="buttons flex-grow-0 flex-shrink-0 mb-20px mr-35px">
            <a :href="'/about-us/brokers/'+activeBroker.slug" v-if="activeBroker" class="broker-link">View Agent</a>
            <button type="reset" class="reset" v-on:click="reset">Reset Filters</button>
            <button type="submit">SEARCH</button>
          </div>
        </div>
      </div>
    </form>
    <div class="view-bar">
      <div class="view-options">VIEW:
        <button :class="'view-btn' + (view==='list'?' active':'')" v-on:click="view='list'"><span
            class="icon list"></span> List
        </button>
        <button :class="'view-btn' + (view==='grid'?' active':'')" v-on:click="view='grid'"><span
            class="icon grid"></span> Grid
        </button>
      </div>
      <div><label :for="id+'_sort'">SORT:</label>
        <div class="select-arrow">
          <select :id="id+'_sort'" v-model="sortSetter">
            <option value=""></option>
            <option value="priceHighToLow">Price: Highest to Lowest</option>
            <option value="priceLowToHigh">Price: Lowest to Highest</option>
            <option value="sqFtHighToLow">SF: Highest to Lowest</option>
            <option value="sqFtLowToHigh">SF: Lowest to Highest</option>
          </select>
        </div>
      </div>
    </div>
    <google-map :results="searchResults" :loading="loading" :expandMap="mobileViewMap"
                v-on:markerVisibility="filterFromMarkers"></google-map>
    <div :class="'results '+view">
      <h3 v-if="searchResults.length === 0 || loading">{{ loading ? 'Loading&hellip;' : 'No results found' }}</h3>
      <div
          class="result"
          v-for="result in sortResults" v-if="!loading && !result.hidden"
          :ref="'property'+result.propertyId"
      >
        <a :href="'/property/'+result.UrlSlug+'/?tab='+result.first_listing.ListingTypeName">
          <div
              class="img"
              :ref="'img' + result.propertyId"
              :style="'background-image:url(\''+(result.loadedImage ? result.ImageFileUrl :'/img/default.jpg?v=1')+'\')'"
          ></div>
        </a>
        <div class="details">
          <a :href="'/property/'+result.UrlSlug+'/?tab='+result.first_listing.ListingTypeName">
            <h2>{{ result.Name ? result.Name : result.AddressLine1 }}</h2>
          </a>
          <p>
            <span v-if="result.Name && result.Name !== result.AddressLine1">{{ result.AddressLine1 }}<br></span>
            {{ result.City }}, {{ result.StateAbbreviatedName }}<br>
            <span v-if="sfRate(result) !== null">{{ sfRate(result) }}</span><br>
            {{ result.spaceDescription }}<br>
            {{ result.SquareFootageLease ? `${result.SquareFootageLease} SF Available for Lease` : null }}
            <br v-if="result.SquareFootageLease">
            {{ result.SquareFootageSale ? `${result.SquareFootageSale} SF Available for Sale` : null }}
          </p>
          <p v-if="view !== 'grid'" v-html="result.first_listing.Notes"></p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import GoogleMap from './Map';

export default {
  components: {GoogleMap},
  name: 'property-search',
  data() {
    return {
      id: null,
      search: this.getQueryObject(),
      mobileViewMap: false,
      mobileViewFilters: false,
      mobileSearchTerm: '',
      searchResults: [],
      visibleMarkers: [],
      resultsType: '',
      sorting: this.$route.query.sort || '',
      loading: false,
      view: 'list',
      brokers: JSON.parse(document.getElementById('brokers-list').innerHTML),
      states: ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL',
        'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH',
        'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT',
        'VT', 'VA', 'WA', 'WV', 'WI', 'WY'],
      propertyTypes: JSON.parse(document.getElementById('property-types-list').innerHTML),
      activeBroker: null
    };
  },
  watch: {
    '$route'(to, from) {
      let oldQueryObject = this.getQueryObject(from);
      let newQueryObject = this.getQueryObject(to);
      this.sorting = to.query.sort || '';
      if (this.queryString(oldQueryObject) !== this.queryString(newQueryObject)) {
        this.search = newQueryObject;
        this.getSearchResults();
      }
    },
  },
  mounted() {
    this.id = this._uid;
    let brokersList = document.getElementById('brokers-list');
    brokersList.parentElement.removeChild(brokersList);
    window.searchScroll = () => Vue.nextTick(this.lazyLoadImgs);
    this.getSearchResults(true);
  },
  computed: {
    searchTab: {
      get() {
        return this.search.tab;
      },
      set(value) {
        if (value !== this.search.tab) {
          this.search.tab = value;
          this.searchAction();
        }
      }
    },
    sortSetter: {
      get() {
        return this.sorting;
      },
      set(sort) {
        this.sorting = sort;
        this.$router.push('/property-search?' + this.queryWithSort(this.getQueryObject()));
      }
    },
    mobileSearch: {
      get() {
        return this.mobileSearchTerm;
      },
      set(search) {
        this.mobileSearchTerm = search;
        let lastComma = search.lastIndexOf(',');
        if (lastComma > -1) {
          this.search.state = search.substring(lastComma + 1).trim();
          this.search.city = search.substring(0, lastComma).trim();
          this.search.keyword = '';
        } else {
          this.search.state = '';
          this.search.city = '';
          this.search.keyword = search.trim();
        }
      }
    },
    sortResults() {
      switch (this.sorting) {
        case '':
          return this.searchResults;
        case 'priceHighToLow':
          return this.searchResults.slice().sort(
              this.resultsType === 'Sales' ?
                  (a, b) => b.salePriceMax - a.salePriceMax :
                  (a, b) => b.leaseRateMax - a.leaseRateMax);
        case 'priceLowToHigh':
          return this.searchResults.slice().sort(
              this.resultsType === 'Sales' ?
                  (a, b) => a.salePriceMax - b.salePriceMax :
                  (a, b) => a.leaseRateMax - b.leaseRateMax);
        case 'sqFtHighToLow':
          return this.searchResults.slice().sort((a, b) => b.squareFeet - a.squareFeet);
        case 'sqFtLowToHigh':
          return this.searchResults.slice().sort((a, b) => a.squareFeet - b.squareFeet);
      }
    },
    searchAllCategories: {
      get() {
        return this.search.propertyType.length === 0;
      },
      set(newValue) {
        if (newValue) {
          this.search.propertyType = [];
        } else {
          this.$forceUpdate();
        }
      }
    },

  },
  methods: {
    getProxiedImageUrl(url) {
      if (!url) {
        return '/img/default.jpg?v=1';
      }

      if (url.startsWith('http') && url.indexOf('levybeffort.dealius.com') !== -1) {
        return '/file-proxy?remote=' + encodeURIComponent(url);
      }

      return url;
    },
    lazyLoadImgs() {
      let tbl = this.searchResults.filter((r) => !r.loadedImage && !r.hidden);
      tbl.forEach((r) => {
        if (!this.$refs['property' + r.propertyId] || r.loadedImage) {
          return;
        }

        let el = this.$refs['img' + r.propertyId][0];
        let rect = el.getBoundingClientRect();

        if (rect.top < window.innerHeight * 2 && rect.bottom >= -window.innerHeight) {
          let img = new window.Image();
          let url = this.getProxiedImageUrl(r.ImageFileUrl);

          img.onload = () => {
            el.style.backgroundImage = `url('${url}')`;
            r.loadedImage = true;
            this.$forceUpdate();
          };

          img.onerror = () => {
            el.style.backgroundImage = `url('/img/default.jpg?v=1')`;
          };

          img.src = url;
        }
      });
    },
    filterFromMarkers(visibleMarkers) {
      let emptyList = visibleMarkers.length === 0;
      this.searchResults.forEach(r => {
        r.hidden = !(emptyList || visibleMarkers.find(vm => vm === r.propertyId));
      });
      this.$forceUpdate();
      Vue.nextTick(() => this.lazyLoadImgs());
    },
    getQueryObject(route = null) {
      if (route === null) route = this.$route;
      return {
        tab: (route.query.tab === 'Sales' ? 'Sales' : route.query.tab === 'Lease' ? 'Lease' : ''),
        propertyType: (route.query.propertyType ? route.query.propertyType.split(',') : []),
        city: route.query.city || '',
        state: route.query.state || '',
        keyword: route.query.keyword || '',
        agentName: route.query.agentName || '',
        priceMin: route.query.priceMin || '',
        priceMax: route.query.priceMax || '',
        squareFtMin: route.query.squareFtMin || '',
        squareFtMax: route.query.squareFtMax || '',
        acreageMin: route.query.acreageMin || '',
        acreageMax: route.query.acreageMax || ''
      }
    },
    sfRate(property) {
      let price = property.first_listing.AskingPriceAmount || property.first_listing.RentAmount;
      if (price === null) return null;
      price = Number(price);
      return price.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
    },
    check(e, val) {
      e.preventDefault();
      let check = e.srcElement.previousSibling;
      if (check.value === 'all')
        this.searchAllCategories = !this.searchAllCategories;
      else {
        if (this.search.propertyType.includes(check.value))
          this.search.propertyType = this.search.propertyType.filter(p => p !== check.value);
        else this.search.propertyType.push(check.value);
      }
    },
    searchPath(fetchAll = false) {
      // return '/api/property-search?'+this.queryString();
      return '/api/property-search?' + this.queryString(null, fetchAll);
    },
    queryString(search = null, fetchAll = false) {
      if (search === null) search = this.search;
      if (fetchAll) {
        return Object.keys(search)
            .filter(k => search[k] != '') // This type coercion is expected ([] == '')
            .map(k => k + '=' + search[k])
            .join('&');
      }
      return Object.keys(search)
          .filter(k => search[k] != '') // This type coercion is expected ([] == '')
          .map(k => k + '=' + search[k])
          .join('&');
    },
    queryWithSort(search = null) {
      return [this.queryString(search), this.sorting].filter(s => s !== '').join('&sort=');
    },
    reset() {
      this.search = {
        tab: this.search.tab,
        propertyType: [],
        city: '',
        state: '',
        keyword: '',
        agentName: '',
        priceMin: '',
        priceMax: '',
        squareFtMin: '',
        squareFtMax: '',
        acreageMin: '',
        acreageMax: ''
      };
      this.searchAction();
    },
    searchAction() {
      this.mobileViewFilters = false;
      this.$router.push('/property-search?' + this.queryWithSort());
    },
    searchSubmit(event) {
      event.preventDefault();
      this.searchAction();
    },
    getSearchResults(fetchAll = false) {
      this.loading = true;
      this.resultsType = this.search.tab;
      axios.get(this.searchPath(fetchAll))
          .then(response => {
            this.searchResults = response.data;
            // this.searchResults.map(r=>r.propertyId);
            this.setActiveBroker();
            this.loading = false;
            window.searchScroll();
            Vue.nextTick(() => window.NavMenu.checkFloating());
          });
    },
    setActiveBroker() {
      if (this.search.agentName) {
        this.activeBroker = this.brokers.find(b => b.search === this.search.agentName);
      } else this.activeBroker = null;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PropertySearch/Search.vue